module.exports = __webpack_public_path__ + "img/card-providers.fb7d9015.svg";